import { useMemo } from 'react';
import {useSelector} from 'react-redux'
import { BROKERS } from 'src/context/constants';
import { useProfile } from 'src/utils/customHook'
import useRouteManager from 'src/utils/customHook/useRouteManager';

const useGuess = () => {
    const profile = useProfile();
    const { brokerNameOnURL } = useRouteManager();

    const isBitkubGuess = useMemo(()=>{
      if (!profile && brokerNameOnURL === BROKERS.bitkub.name) return true
      return false
    },[profile,brokerNameOnURL])

    return {
      isBitkubGuess
    }
}

export default useGuess